import type { FC, ReactNode } from "react";

export interface TranscriptContainerProps {
  /** Transcript messages, call markers, and any events between them. */
  children: ReactNode;
}

export const TranscriptContainer: FC<TranscriptContainerProps> = (props) => {
  return <div className="space-y-2 text-sm">{props.children}</div>;
};
